export default __webpack_public_path__ + "static/media/icons8-cat_footprint.0cdfdee7.svg";